import React, { useMemo, useEffect, useState } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { getPortsForVm } from 'openstack/components/networks/actions'
import { listFloatingIps } from 'openstack/components/networks/floating-ips/actions'
import { useSelector } from 'react-redux'
import { floatingIpsSelector } from 'openstack/components/networks/floating-ips/selectors'
import { virtualMachinesLiteByIdSelector } from 'openstack/components/vms/selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function AvailableVmPortsPicklist({
  disabled = false,
  name = 'vmPort',
  label = 'VM Port',
  vmId,
  ...rest
}) {
  const [vmPorts, setVmPorts] = useState([])
  const [loadingVmPorts, setLoadingVmPorts] = useState(true)
  const { loading: loadingFloatingIps } = useListAction(listFloatingIps)
  const floatingIps = useSelector(floatingIpsSelector)
  const vmsById = useSelector(virtualMachinesLiteByIdSelector)

  useEffect(() => {
    if (!vmId) {
      setLoadingVmPorts(false)
      return
    }
    const getPorts = async () => {
      try {
        const response = await getPortsForVm({ vmId })
        setVmPorts(response)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadingVmPorts(false)
      }
    }
    getPorts()
  }, [vmId])

  const options = useMemo(() => {
    // will need to filter out taken private IPs
    const vm = vmsById[vmId]
    const fixedIpsWithFloatingIp = floatingIps.map((floatingIp) => floatingIp.fixed_ip_address)
    const freeVmPorts = vmPorts.filter((port) => {
      const fixedIp = port?.fixed_ips?.[0]?.ip_address
      return !fixedIpsWithFloatingIp.includes(fixedIp)
    })
    return freeVmPorts.map((port) => ({
      label: `${vm?.name || vm?.id}: ${port?.fixed_ips?.[0]?.ip_address}`,
      value: port.id,
    }))
  }, [vmPorts, vmId, vmsById, floatingIps])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loadingVmPorts || loadingFloatingIps}
      enableSearch
      items={options}
    />
  )
}
